import axios, { type AxiosRequestConfig } from 'axios';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import _ from 'lodash';

const TIMEOUT = 1 * 30 * 1000;
const isServer = typeof window === 'undefined';
axios.defaults.timeout = TIMEOUT;
const dev = process.env.NODE_ENV !== 'production';

export const TOKEN_KEY = 'jwt-token';

const tokenFunction = (req: any) => {
  if (isServer) {
    const cookies = _.get(req, 'headers.cookie', '');

    const jwtCookie =
      cookies
        .split(';')
        .map((x: any) => x.trim())
        .find((x: any) => _.startsWith(x, `${TOKEN_KEY}=`)) || '';

    return jwtCookie.replace(`${TOKEN_KEY}=`, '');
  }

  return Cookies.get(TOKEN_KEY);
};

export const getToken = tokenFunction;

const getBaseUrl = (req: any) => {
  if (isServer) {
    if (dev) {
      return req && 'http://127.0.0.1:3000/api/';
    }
    return req && 'http://supplier-gateway:8080/api/';
  }
  return '/api/';
};

const getAxiosInstanceWithoutErrorChecking = (request: any) => {
  const token = getToken(request);
  const baseURL = getBaseUrl(request);
  const headers = {} as { [key: string]: string };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  const instance = axios.create({
    baseURL,
    headers,
  });

  return instance;
};

const getAxiosInstance = (request?: any) => {
  const onResponseSuccess = (response: any) => response;

  const onResponseError = (err: any) => {
    const status = err && (err.status || (err.response && err.response.status));
    console.log(err);
    if (axios.isCancel(err)) {
      return Promise.reject(err);
    }
    if (status === 401) {
      toast(`Du är inte längre inloggad`, {
        type: toast.TYPE.ERROR,
      });
      window.location.href = '/login';
    } else if (status === 503) {
      window.location.href = '/maintenance';
    } else if (getToken(err)) {
      const message = _.get(err, 'response.data.message');
      const toastText = message
        ? `${message} (${status})`
        : `Anrop misslyckades (${status})`;
      toast(toastText, {
        type: toast.TYPE.ERROR,
      });
    }
    return Promise.reject(err);
  };

  const token = getToken(request);
  const baseURL = getBaseUrl(request);
  const headers = {} as { [key: string]: string };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  const instance = axios.create({
    baseURL,
    headers,
  });

  instance.interceptors.response.use(onResponseSuccess, onResponseError);

  return instance;
};

export { getAxiosInstanceWithoutErrorChecking };

export default getAxiosInstance;
